<template>
  <div class="content-wrapper bg-white dark:bg-darkblue-900 flex flex-col w-full relative">
    <slot name="header" />
    <article class="content flex flex-col flex-auto overflow-y-auto lg:overflow-y-hidden w-full">
      <div
        :class="{'lg:max-w-twocol ':!toEdge}"
        class="w-full flex flex-col lg:flex-row lg:mr-auto flex-grow">
        <div class="px-4 lg:px-10 w-full md:w-11.5/12 lg:max-w-detail overflow-y-hidden lg:overflow-y-auto lg:h-[calc(100vh-140px)]">
            <slot name="LeftCol" />
        </div>
        <div class="w-full dark:bg-darkblue-800 dark:text-darkblue-200">
            <slot name="RightCol"/>
        </div>
      </div>
    </article>
    <slot name="layout-extend" />
  </div>
</template>

<script>
export default {
  name: 'layout-detail-two-columns',
  props: {
    toEdge: {
      type: Boolean,
      default: false
    }
  }
}
</script>
